export default __webpack_public_path__ + "static/media/IMG-20211128-WA0006.9268f361.jpg";